import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { sectorColor } from "../lib/colors";

export interface SectorSlice {
  sector: string;
  value: number;
}

/** Donut of a manager's slots across sectors, with an inline legend. */
export function SectorDonut({ data }: { data: SectorSlice[] }) {
  if (data.length === 0) {
    return (
      <div className="flex h-[180px] items-center justify-center text-sm text-faint">
        No open positions yet.
      </div>
    );
  }
  const total = data.reduce((a, s) => a + s.value, 0);
  const colored = data.map((s, i) => ({ ...s, color: sectorColor(i) }));

  return (
    <div className="flex items-center gap-4">
      <div className="h-[160px] w-[160px] shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={colored}
              dataKey="value"
              nameKey="sector"
              innerRadius={48}
              outerRadius={76}
              paddingAngle={2}
              stroke="none"
              isAnimationActive={false}
            >
              {colored.map((s) => (
                <Cell key={s.sector} fill={s.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className="min-w-0 flex-1 space-y-1 text-sm">
        {colored.map((s) => (
          <li key={s.sector} className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: s.color }} />
            <span className="min-w-0 flex-1 truncate text-muted">{s.sector}</span>
            <span className="num text-fg">{s.value}</span>
            <span className="num w-10 text-right text-faint">
              {Math.round((s.value / total) * 100)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
